//Angular
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { ActivatedRoute } from '@angular/router';
//App animations
import { AppAnimations } from 'src/app/_shared/animations';
//App Services
import { GridService, SkeletonLoaderService } from 'src/app/_core/services';
//App Data
import { BillingRunInfo } from 'src/app/_shared/models/system.model';
import { GridColumnsBillingOperations, VisibleState } from 'src/app/app.data';
import { RestResponse } from 'src/app/_shared/models';
import { SettingsService } from '../../_services/api/settings.service';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';
import { HttpParamsInterface } from 'src/app/_shared/interfaces/http-params.interface';

@Component({
  animations: [AppAnimations],
  selector: 'billing-operations-detail',
  templateUrl: './billing-operations-detail.component.html'
})

export class BillingOperationDetailComponent implements OnInit, OnDestroy {
  billRunId: number;
  collectionOfBillingRuns: Array<BillingRunInfo>;
  isBillingRunReady: boolean = false;
  gridBillingItemsCurrentPageNumber: number = 1;
  gridBillingItemsItemsPerPage: number = 10;
  gridBillingItemsTotalItems: number;
  gridBillingItemsTotalPages: number;
  statusMessageBillingsItems: VisibleState;
  private subs = new Unsubscriber();

  @Input() _visibleState = VisibleState;
  @Input() _gridCols = GridColumnsBillingOperations;

  constructor(
    public _grid: GridService,
    private _iconRegistry: MatIconRegistry,
    public _meta: MetaService,
    private _route: ActivatedRoute,
    private _sanitizer: DomSanitizer,
    public _skeleton: SkeletonLoaderService,
    private settingsService: SettingsService,
  ) {
    this._iconRegistry.addSvgIcon('ico-back', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-back-03.svg'));

    this.statusMessageBillingsItems = VisibleState.isHidden;

    this.subs.addSub = this._route.params.subscribe(params => {
      this.billRunId = params['id'];
    });
  }

  getBillingById(_invoiceId: number) {
    const httpParams: HttpParamsInterface = {
      pageNo:this.gridBillingItemsCurrentPageNumber,
      itemPerPage: this.gridBillingItemsItemsPerPage
    }
    this.subs.addSub = this.settingsService.getBillingRunByBillingRunId(this.billRunId, httpParams).subscribe(
      (res: RestResponse) => {

        this.collectionOfBillingRuns = <Array<any>>res.data;

        if (this.collectionOfBillingRuns.length > 0) {
          this.gridBillingItemsCurrentPageNumber = res.currentPageNumber;
          this.gridBillingItemsItemsPerPage = res.itemsPerPage;
          this.gridBillingItemsTotalItems = res.totalItems;
          this.gridBillingItemsTotalPages = res.totalPages;
          this.statusMessageBillingsItems = VisibleState.isHidden;
        } else {
          this.statusMessageBillingsItems = VisibleState.isVisible;
        }

        this.isBillingRunReady = true;
        console.log('invoices-detail.component.ts - getBillingById() [SUCCESS]');
      },
      (err: RestResponse) => {
        let code = err.error.code;
        this._skeleton.skeletonGridLoader = true;
        this._skeleton.skeletonGridDataLoader = true;
        this.isBillingRunReady = true;
        console.log(`invoices-detail.ts - getBillingById() [ERROR] Err. ${code}`);
      }
    );

  }

  ngOnInit(): void {
    this.getBillingById(this.billRunId);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  onPageChange(event){
    this.gridBillingItemsCurrentPageNumber = event.pageIndex + 1;
    this.getBillingById(this.billRunId);
  }
}


